import { makeStyles } from "tss-react/mui"
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, MenuItem, Typography } from "@mui/material"
import { FormikDropdown, FormikSwitch, FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { FormikImageUpload } from "../../../../../../shared/components/Formik/FormikImageUpload"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { ConfigureLanguage, CreateUpdateTemplateFormValues } from "../supplierPosSettingsTypes"
import { iterateStringEnum } from "../../../../../../lib/enums"
import { FrontPageLayout } from "./FrontPageLayout"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"

const useStyles = makeStyles()((theme) => ({
    switchTitle: {
        color: theme.palette.tailwind.slate[600],
    },

    infoWrap: {
        display: "grid",
        gridTemplateColumns: "0.75rem 1fr",
        background: theme.palette.tailwind.sky[100],
        borderRadius: "0.5rem",
        gap: "0.75rem",
        padding: "0.75rem",
        color: theme.palette.tailwind.sky[800],
        width: "100%",
        marginTop: "1.25rem",
    },
}))

type CreateUpdateTemplateFormContentProps = Readonly<{}>

export function CreateUpdateTemplateFormContent({}: CreateUpdateTemplateFormContentProps) {
    const { classes } = useStyles()

    return (
        <>
            <StandardForm>
                <StandardMainPanel>
                    <LocalizedStrict id="supplier-admin-pos-settings-template-name-field-label" attrs={{ label: true }}>
                        <FormikTextField name="name" label="Template name" fullWidth />
                    </LocalizedStrict>

                    <LocalizedStrict
                        id="supplier-admin-pos-settings-template-languageCode-field-label"
                        attrs={{ label: true }}
                    >
                        <FormikDropdown<CreateUpdateTemplateFormValues> name="languageCode" label="Language">
                            {[...iterateStringEnum(ConfigureLanguage)].map((code) => (
                                <MenuItem key={code} value={code}>
                                    <LocalizedEnum base="supplier-admin-pos-settings-lang" enumValue={code}>
                                        <span>{code}</span>
                                    </LocalizedEnum>
                                </MenuItem>
                            ))}
                        </FormikDropdown>
                    </LocalizedStrict>

                    <FrontPageLayout />

                    <LocalizedStrict
                        id="supplier-admin-pos-settings-template-title-field-label"
                        attrs={{ label: true }}
                    >
                        <FormikTextField name="content.centerContent.title.label" label="Title" fullWidth />
                    </LocalizedStrict>
                    <LocalizedStrict
                        id="supplier-admin-pos-settings-template-subtitle-field-label"
                        attrs={{ label: true }}
                    >
                        <FormikTextField name="content.centerContent.subtitle.label" label="Subtitle" fullWidth />
                    </LocalizedStrict>
                    <LocalizedStrict
                        id="supplier-admin-pos-settings-template-button-field-label"
                        attrs={{ label: true, helperText: true }}
                    >
                        <FormikTextField
                            name="content.centerContent.purchaseButton.label"
                            label="Button text"
                            helperText="Customize the text of the start purchase button."
                            fullWidth
                        />
                    </LocalizedStrict>

                    <LocalizedStrict
                        id="supplier-admin-pos-settings-template-companyLogo-field-label"
                        attrs={{ label: true }}
                    >
                        <FormikImageUpload
                            label="Upload company logo:"
                            name="content.merchantLogo"
                            typeOfEntity="POS_TEMPLATE_LOGO"
                            bottomContent={
                                <Box className={classes.infoWrap}>
                                    <FontAwesomeIcon size="sm" icon={faCircleInfo} />
                                    <LocalizedStrict id="supplier-admin-pos-settings-template-companyLogo-info">
                                        <Typography variant="caption">
                                            Image hints: background should be transparent. We recommend using a 180x180
                                            px image with logo centered inside.
                                        </Typography>
                                    </LocalizedStrict>
                                </Box>
                            }
                        />
                    </LocalizedStrict>
                </StandardMainPanel>
                <LocalizedStrict id="supplier-admin-pos-settings-template-shortcuts" attrs={{ title: true }}>
                    <StandardSidePanel title="Shortcuts" variant="collapsible">
                        <FormikSwitch name="content.shortcuts.helpCenter">
                            <LocalizedStrict id="supplier-admin-pos-settings-template-shortcuts-help-field">
                                <Typography variant="body2" className={classes.switchTitle}>
                                    Help / terms and conditions:
                                </Typography>
                            </LocalizedStrict>
                        </FormikSwitch>
                        <FormikSwitch name="content.shortcuts.downloadApp">
                            <LocalizedStrict id="supplier-admin-pos-settings-template-shortcuts-downloadApp-field">
                                <Typography variant="body2" className={classes.switchTitle}>
                                    Download GoPay app:
                                </Typography>
                            </LocalizedStrict>
                        </FormikSwitch>
                    </StandardSidePanel>
                </LocalizedStrict>
            </StandardForm>
        </>
    )
}
